<template>
  <b-modal class="modal-md" id="createPaymentConfig" ref="createPaymentConfig-modal" :title="'Create Payment Configuration'" :header-bg-variant="'secondary'" hide-backdrop okVariant="secondary" @show="clearData()" @hide="closeModal()">
    <template slot="modal-header" slot-scope="{ close }">
      <h5 class="modal-title text-light"><fontAwesomeIcon :icon="['fas', 'money-check']" size="1x" class="mr-2"/> Create Payment Configuration</h5>
      <button aria-label="Close" class="close" data-dismiss="modal" type="button" @click="close()"><span aria-hidden="true" class="text-light">X</span></button>
    </template>
    <template slot="default" slot-scope="{ close }">
      <form>
        <div class="configDiv mb-1 flex-align" :id="'configDiv'+key" v-for="(value, key) in inputs" :key="key">
          <input type="text" name="configKey[]" placeholder="Config Key" v-model="value.configKey"/> &nbsp;
          <input type="text" name="configValue[]" placeholder="Config Value" v-model="value.configValue"/> &nbsp;
          <i class="deleteConfigDiv os-icon os-icon-x-square remove-icon" @click="deleteConfigDiv(key)"></i>
        </div>    
      </form>
      <button class="btn btn-primary mt-2" @click="addMoreConfigFields()">Add New Configuration</button>
    </template>
    <template slot="modal-footer" slot-scope="{ cancel, close }">
      <div v-if="counter > 0">
        <button aria-label="Cancel" data-dismiss="modal" class="btn btn-secondary mr-2" type="button" @click="cancel()">
          <fontAwesomeIcon :icon="['fa', 'ban']" class="text-light mr-2"/>Cancel
        </button>
        <button aria-label="AddPaymentConfiguration" data-dismiss="modal" class="btn btn-primary" type="button" @click="addPaymentConfiguration()">
          <fontAwesomeIcon :icon="['fa', 'save']" class="text-light mr-2" />Create Configuration
        </button>
      </div>
      <div v-else>
        <h5 style="color: red">You must add at least one configuration before saving!</h5>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ResponseInfo from '@/components/ResponseInfo.vue'

export default {
  name: 'ModalPaymentConfiguration',
  props: ['paymentMethod'],
  data () {
    return {
      counter: 1,
      inputs: [{
        configKey: '',
        configValue: ''
      }],
    }
  },
  computed:{
    ...mapGetters(['getResponseInfo'])
  },
  methods:{
    clearData() {
      this.inputs = [
        {
          configKey: '',
          configValue: ''
        }
      ]
    },

    addPaymentConfiguration() {
      this.$store.dispatch('onlinePaymentStore/addPaymentConfiguration', {
        inputs: this.inputs,
        paymentMethod: this.$props.paymentMethod
      }).then(response => {
        if(response.status && response.status == 'success') {
          this.$parent.checkMissingPaymentConditions()
          this.$parent.closeModal()
        }
      })
    },

    addMoreConfigFields() {
      this.counter++
      
      this.inputs.push({
        configKey: '',
        configValue: '',
      });
    },

    deleteConfigDiv(key) {
      this.inputs.splice(key, 1)
      this.counter--
    },

    closeModal() {
      this.$parent.closeModal()
    }
  },
  created() {

  },
  components: {
    
  }
}
</script>

<style scoped>
.flex-align {
  display: flex;
  align-items: center;
}

.remove-icon {
  font-size: 24px;
  color: red;
  cursor: pointer;
}
</style>
